import React from "react";

const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="cc-empty">
    {Icon && (
      <span className="cc-empty__icon">
        <Icon size={22} strokeWidth={2} aria-hidden="true" />
      </span>
    )}
    <p className="cc-empty__title">{title}</p>
    {description && <p className="cc-empty__description">{description}</p>}
    {action && <div className="cc-empty__action">{action}</div>}
  </div>
);

export default EmptyState;
